import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useApp();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { nav("/"); return; }
    (async () => {
      try {
        await api.post("/auth/google/session", null, { headers: { "X-Session-ID": sid } });
        await refresh();
        window.history.replaceState(null, "", window.location.pathname);
        nav("/lobby");
      } catch {
        nav("/login");
      }
    })();
  }, [nav, refresh]);

  return <div className="min-h-screen flex items-center justify-center text-[#d4af37] font-serif">Signing you in…</div>;
}
